module.exports = __webpack_public_path__ + "img/1.27b9f234.jpg";